import React from 'react';
import './test.css';



const Test = () => {
    return (
        <div data-aos="fade-up">
           <div className="box-con" >
             <div className="box1">
                <div className="box2" >
                    <h2 className='content-title'>Our Vision , mission & values</h2>
                    <div className="box3" >

                        <div className="one">
                            <div className='new-bg'>
                                <img src={require("../../assets/mission bg.png")} alt="" />
                            </div>

                            <img src={require("../../assets/mission new.png")} alt="" className='icons' />
                            <div className="text">
                                <h3>Mission</h3>
                                <p>We are committed to enriching lives by making affordable, high-quality generic medicines
                                    accessible to everyone. By partnering with others, we ensure that cost is never a barrier to
                                    healthcare and that our products contribute to the well-being of patients around the world. </p>
                            </div>
                        </div>
                        <div className="one">
                            <div className="new-bg">
                                <img src={require("../../assets/vision bg.png")} alt="" />
                            </div>

                            <img src={require("../../assets/vision new.png")} alt="" className='icons' />
                            <div className="text">
                                <h3>Vision</h3>
                                <p>Our vision is to lead the future of generic medicines by setting new standards for
                                    affordability, quality, and accessibility. We envision a world where everyone has access to
                                    safe and effective medications, empowering healthier communities and a brighter tomorrow.</p>
                            </div>
                        </div>
                        <div className="one">

                            <div className="new-bg">
                                <img src={require("../../assets/value bg.png")} alt="" />
                            </div>

                            <img src={require("../../assets/values-01.png")} alt="" className='icons' />
                            <div className="text">
                                <h3>Values</h3>
                                <p>Our values define who we are and guide every decision we make. We uphold integrity by always doing what is right, and we never compromise on quality, ensuring the highest standards in every product we deliver. </p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
           </div>
        </div>
    );
}

export default Test;
